import React, { useEffect, useRef, useState } from 'react';

const CustomFitty = ({ children, maxSize = 24, minSize = 12, style = {} }) => {
    const containerRef = useRef(null);
    const textRef = useRef(null);
    const [fontSize, setFontSize] = useState(maxSize);

    const fitText = (skip) => {
        const container = containerRef.current;
        const text = textRef.current;

        if (container && text) {
            text.style.fontSize = `${maxSize}px`;
            const spanXPadding = 25; /*this number should be the same with the left and right padding of the span*/
            const scale = (container.offsetWidth-spanXPadding) / (text.scrollWidth);
            const newSize = Math.max(Math.min(maxSize, maxSize * scale), minSize);
            setFontSize(newSize);
        }
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            fitText();
        }, 200);

        const resizeObserver = new ResizeObserver(() => fitText());
        if (containerRef.current) {
            resizeObserver.observe(containerRef.current);
        }

        return () => {
            clearTimeout(timeout);

            resizeObserver.disconnect()
        };
    }, [children, maxSize, minSize]); //eslint-disable-line react-hooks/exhaustive-deps
    return (
        <div ref={containerRef} style={{width: '100%', textWrap: 'nowrap', overflowX: "hidden", ...style}}>
            <div
                ref={textRef}
                aria-hidden={true}
                style={{whiteSpace: 'nowrap', transition: 'font-size 0.2s', visibility: "hidden", lineHeight: "0"}}
            >
                {children}
            </div>
            <span key={fontSize} style={{fontSize: `${fontSize}px`, whiteSpace: 'nowrap', transition: 'font-size 0.2s',}}>
                {children}
            </span>
        </div>
    );
};

export default CustomFitty;
